// CagriBellAdmin.js
// Konum: src/CagriBellAdmin.js — Route: /admin

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebaseClient';
import { authFetch } from './authFetch';
import GarsonCagirmaSekmesi from './GarsonCagirmaSekmesi';

const BACKEND = process.env.REACT_APP_API_URL;

export default function CagriBellAdmin() {
  const navigate = useNavigate();
  const [business, setBusiness] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [logoUrl, setLogoUrl] = useState('');
  const [logoKaydediliyor, setLogoKaydediliyor] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [videoKaydediliyor, setVideoKaydediliyor] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate('/');
        return;
      }
      try {
        const res = await authFetch(`${BACKEND}/call-waiter/business/by-uid/${user.uid}`);
        const data = await res.json();
        if (!data) {
          navigate('/');
          return;
        }
        setBusiness(data);
        setLogoUrl(data.logoUrl || '');
        setVideoUrl(data.videoUrl || '');
      } catch (err) {
        console.error('İşletme bilgisi alınamadı:', err);
      }
      setYukleniyor(false);
    });
    return () => unsub();
  }, [navigate]);

  const cikisYap = async () => {
    await signOut(auth);
    navigate('/');
  };

  const logoKaydet = async () => {
    setLogoKaydediliyor(true);
    try {
      await authFetch(`${BACKEND}/call-waiter/business/${business.id}/logo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ logoUrl: logoUrl.trim() }),
      });
      setBusiness((prev) => ({ ...prev, logoUrl: logoUrl.trim() }));
      alert('Logo kaydedildi.');
    } catch (err) {
      alert('Logo kaydedilemedi.');
    }
    setLogoKaydediliyor(false);
  };

  const videoKaydet = async () => {
    setVideoKaydediliyor(true);
    try {
      await authFetch(`${BACKEND}/call-waiter/business/${business.id}/video`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ videoUrl: videoUrl.trim() }),
      });
      setBusiness((prev) => ({ ...prev, videoUrl: videoUrl.trim() }));
      alert('Video kaydedildi.');
    } catch (err) {
      alert('Video kaydedilemedi.');
    }
    setVideoKaydediliyor(false);
  };

  if (yukleniyor) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center text-slate-400">
        Yükleniyor...
      </div>
    );
  }

  const tvUrl = `${window.location.origin}/tv/${business.id}`;

  return (
    <div className="min-h-screen bg-gray-950 px-6 py-8">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            {business.logoUrl && (
              <img src={business.logoUrl} alt="Logo" className="w-10 h-10 rounded-lg object-cover" />
            )}
            <div>
              <h1 className="text-white text-xl font-bold">{business.businessName}</h1>
              <p className="text-slate-500 text-sm mt-0.5">Çağrı Bell Yönetim Paneli</p>
            </div>
          </div>
          <button
            onClick={cikisYap}
            className="border border-slate-700 text-slate-400 rounded-lg px-4 py-2 text-sm"
          >
            Çıkış Yap
          </button>
        </div>

        <div className="bg-slate-800 rounded-2xl p-5 mb-6">
          <p className="text-slate-400 text-xs uppercase tracking-wider font-semibold mb-2">
            TV Ekranı Linki
          </p>
          <p className="text-white text-sm break-all">{tvUrl}</p>
          <p className="text-slate-500 text-xs mt-2">
            Bu linki restoran TV'sindeki kiosk tarayıcısına gir, tam ekran açık bırak.
          </p>
        </div>

        <div className="bg-slate-800 rounded-2xl p-5 mb-6">
          <p className="text-slate-400 text-xs uppercase tracking-wider font-semibold mb-2">
            İşletme Logosu
          </p>
          <p className="text-slate-500 text-xs mb-3">
            TV ekranında ve müşteri buton sayfasında gösterilir. Bir resim barındırma
            sitesine (örn: imgur) yüklediğin logonun linkini buraya yapıştır.
          </p>
          <div className="flex gap-2">
            <input
              value={logoUrl}
              onChange={(e) => setLogoUrl(e.target.value)}
              placeholder="https://..."
              className="flex-1 bg-slate-900 border border-slate-700 rounded-lg px-3.5 py-2.5 text-sm text-white focus:outline-none focus:border-orange-400"
            />
            <button
              onClick={logoKaydet}
              disabled={logoKaydediliyor}
              className="bg-orange-500 text-white rounded-lg px-4 py-2.5 text-sm font-semibold disabled:opacity-60"
            >
              Kaydet
            </button>
          </div>
        </div>

        <div className="bg-slate-800 rounded-2xl p-5 mb-6">
          <p className="text-slate-400 text-xs uppercase tracking-wider font-semibold mb-2">
            Tanıtım Videosu (opsiyonel)
          </p>
          <p className="text-slate-500 text-xs mb-3">
            Ayarlarsan TV ekranı boşta iken logo yerine bu video döner (sessiz, otomatik
            tekrar eder) — reklam/tanıtım alanı olarak kullanılabilir. Doğrudan bir .mp4
            linki olmalı. Boş bırakırsan TV logo (o da yoksa "Çağrı bekleniyor" yazısını) gösterir.
          </p>
          <div className="flex gap-2">
            <input
              value={videoUrl}
              onChange={(e) => setVideoUrl(e.target.value)}
              placeholder="https://.../tanitim.mp4"
              className="flex-1 bg-slate-900 border border-slate-700 rounded-lg px-3.5 py-2.5 text-sm text-white focus:outline-none focus:border-orange-400"
            />
            <button
              onClick={videoKaydet}
              disabled={videoKaydediliyor}
              className="bg-orange-500 text-white rounded-lg px-4 py-2.5 text-sm font-semibold disabled:opacity-60"
            >
              Kaydet
            </button>
          </div>
        </div>

        <div className="bg-white rounded-2xl px-5">
          <GarsonCagirmaSekmesi restaurantId={business.id} />
        </div>
      </div>
    </div>
  );
}